// extracted by mini-css-extract-plugin
module.exports = {"day":"day-3O8IX","day_selected":"day_selected-2_1Ta"};